import { useState } from 'react';
import type { Country } from '../types.js';
import { useResource } from '../api.js';

export function DestinationCountries({ value, onChange, countries }: {
  value: string[];
  onChange: (value: string[]) => void;
  countries: Country[];
}) {
  const [query, setQuery] = useState('');
  const selected = new Set(value);
  const matches = countries.filter(country =>
    [country.name, country.code, country.alias, country.alpha3].some(text => text?.toLowerCase().includes(query.trim().toLowerCase())));
  return <div className="destination-countries">
    <p className="field-help">Select every destination covered by this link. Leave all unchecked if delivery is unconfirmed. Price, currency and delivery details apply to all selected countries.</p>
    <p className="destination-selection" role="status">{value.length ? value.map(code => countries.find(country => country.code === code)?.name ?? code).join(', ') : 'No destinations selected'}</p>
    <label>Find a country<input type="search" value={query} onChange={event => setQuery(event.target.value)} placeholder="Country name or code" /></label>
    <div className="destination-options">
      {matches.map(country => <label className="checkbox-field" key={country.code}>
        <input type="checkbox" checked={selected.has(country.code)} onChange={event => onChange(event.target.checked ? [...value, country.code] : value.filter(code => code !== country.code))} />
        {country.name}
      </label>)}
      {!matches.length && <p className="field-help">No countries match your search.</p>}
    </div>
  </div>;
}

export function InlineDestinationCountries({ value, onChange }: { value: string[]; onChange: (value: string[]) => void }) {
  const { data, loading, error } = useResource<Country[]>('/api/v1/admin/countries');
  if (error) return <p role="alert" className="error-message">{error}. Close and reopen the editor to try again.</p>;
  if (loading || !data) return <p role="status">Loading countries…</p>;
  return <DestinationCountries value={value} onChange={onChange} countries={data} />;
}
